import { FC } from "react";
import { Icon } from "../../graphic/Icon";
import styles from "./PageHeader.scss";
import { PageHeaderTypes } from "./PageHeader.types";

export const PageHeader: FC<PageHeaderTypes> = ({ icon, title, subtitle }) => {
    return (
        <div className={styles.base}>
            {/* Icon */}
            {icon ? (
                <div className={styles.icon}>
                    <Icon name={icon} size="auto" />
                </div>
            ) : null}

            {/* Titles */}
            <div className={styles.titles}>
                <h1 className={styles.mainTitle}>{title}</h1>
                {subtitle ? (
                    <div className={styles.subTitle}>
                        <div className={styles.text}>{subtitle}</div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
